import { trackRecommendationClickEntityEvent, trackRecommendationClickEvent } from '@sitecore-search/data';
import { RecommendationActionTypes } from '@sitecore-search/widgets';
import useBaseWidget from '../../../hooks/useBaseWidget.js';
import useQuery from '../../../hooks/useQuery.js';
import useWidget from '../../../hooks/useWidget.js';
import useWidgetActionsHandler from '../../../hooks/useWidgetActionsHandler.js';
import useWidgetRef from '../../../hooks/useWidgetRef.js';
import useWidgetState from '../../../hooks/useWidgetState.js';
function useRecommendation(config) {
    const { rfkId, dispatch } = useBaseWidget();
    const control = useWidget();
    if (!control.isInitialized()) {
        control.initialize(config || {});
    }
    const { query, options, actions } = control;
    const state = useWidgetState();
    const queryResult = useQuery(query);
    const widgetRef = useWidgetRef();
    useWidgetActionsHandler((action) => {
        switch (action.type) {
            case RecommendationActionTypes.NAVIGATION_NEXT: {
                const { index } = action.payload;
                trackRecommendationClickEvent(rfkId, '', {
                    actionCause: 'navigation',
                    index,
                });
                break;
            }
            case RecommendationActionTypes.NAVIGATION_PREV: {
                const { index } = action.payload;
                trackRecommendationClickEvent(rfkId, '', {
                    actionCause: 'navigation',
                    index,
                });
                break;
            }
            case RecommendationActionTypes.ITEM_CLICKED: {
                const { id, entity, index, sourceId } = action.payload;
                trackRecommendationClickEntityEvent(rfkId, entity, {
                    index,
                    items: [{ id, sourceId }],
                });
                break;
            }
        }
    }, [rfkId, query]);
    return { widgetRef, rfkId, state, queryResult, actions, options, dispatch, query };
}
export default useRecommendation;
